import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { CONTACT_FILES_QUERY_KEY } from './useContactFilesQuery';

interface UploadContactFilesMutationParams {
	contactId: string;
	files: File[];
}

export function useUploadContactFilesMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ contactId, files }: UploadContactFilesMutationParams) => {
			const formData = new FormData();
			files.forEach(file => formData.append('files', file));

			return new Promise<Api.ISharedFile[]>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceWithOperationResults<Api.ISharedFile[]>(
					Api.ImpersonationBroker.composeApiUrl({ urlPath: `contact/${encodeURIComponent(contactId)}/files` }),
					'POST',
					formData,
					opResult => resolve(opResult.value),
					reject
				);
			});
		},
		onSuccess: (_, { contactId }) => {
			queryClient.invalidateQueries({ queryKey: [CONTACT_FILES_QUERY_KEY, contactId] });
			onSuccess?.();
		},
		onError,
	});
}
